const initialState = {
    get: {
        statements: null,
        statement: null,
        propertyMaps: null,
        propertyMap: null,
        areas: null,
        area: null,
        pools: null,
        pool: null,
        // products-only refresh for a pool (kept separate to avoid overwriting full detail)
        poolProducts: null,
        pointsOfInterest: null,
        mappings: null,
        mapping: null,
    },
    post: {
        statement: {},
        propertyMap: {},
        area: {},
        pool: {},
        mapping: {},
    },
    patch: {
        statement: {},
        propertyMap: {},
        area: {},
        pool: {},
        mapping: {},
    },
    delete: {
        statement: {},
        propertyMap: {},
        propertyMapImage: {},
        propertyMapArea: {},
        propertyMapPoi: {},
        area: {},
        areaPool: {},
        areaPoi: {},
        areaImage: {},
        pool: {},
        poolStatement: {},
        poolImage: {},
        poolPoi: {},
        mapping: {},
    },
    batch: {
        propertyMap: null,
        area: null,
        pool: null,
        mapping: null,
    },
};

const cabanasMappingReducer = (state = initialState, action) => {
    switch (action.type) {
        case "STATEMENTS_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    statements: action.value,
                },
            };
        case "STATEMENT_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    statement: action.value,
                },
            };
        case "STATEMENT_RESPONSE_POST":
            return {
                ...state,
                post: {
                    ...state.post,
                    statement: action.value,
                },
            };
        case "STATEMENT_RESPONSE_PATCH":
            return {
                ...state,
                patch: {
                    ...state.patch,
                    statement: action.value,
                },
            };
        case "STATEMENT_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    statement: action.value,
                },
            };
        case "PROPERTY_MAPS_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    propertyMaps: action.value,
                },
            };
        case "PROPERTY_MAP_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    propertyMap: action.value,
                },
            };
        case "PROPERTY_MAP_RESPONSE_POST":
            return {
                ...state,
                post: {
                    ...state.post,
                    propertyMap: action.value,
                },
            };
        case "PROPERTY_MAP_RESPONSE_PATCH":
            return {
                ...state,
                patch: {
                    ...state.patch,
                    propertyMap: action.value,
                },
            };
        case "PROPERTY_MAP_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    propertyMap: action.value,
                },
            };
        case "PROPERTY_MAP_IMAGE_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    propertyMapImage: action.value,
                },
            };
        case "PROPERTY_MAP_AREA_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    propertyMapArea: action.value,
                },
            };
        case "PROPERTY_MAP_POI_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    propertyMapPoi: action.value,
                },
            };
        case "AREAS_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    areas: action.value,
                },
            };
        case "AREAS_RESET":
            return {
                ...state,
                get: {
                    ...state.get,
                    areas: null,
                },
            };
        case "AREA_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    area: action.value,
                },
            };
        case "AREA_RESPONSE_POST":
            return {
                ...state,
                post: {
                    ...state.post,
                    area: action.value,
                },
            };
        case "AREA_RESPONSE_PATCH":
            return {
                ...state,
                patch: {
                    ...state.patch,
                    area: action.value,
                },
            };
        case "AREA_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    area: action.value,
                },
            };
        case "AREA_POOL_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    areaPool: action.value,
                },
            };
        case "AREA_POI_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    areaPoi: action.value,
                },
            };
        case "AREA_IMAGE_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    areaImage: action.value,
                },
            };
        case "POOLS_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    pools: action.value,
                },
            };
        case "POOLS_RESET":
            return {
                ...state,
                get: {
                    ...state.get,
                    pools: null,
                },
            };
        case "POOL_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    pool: action.value,
                },
            };
        // products-only response slice
        case "POOL_FOR_PRODUCTS_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    poolProducts: action.value,
                },
            };
        case "RESET_POOL_PRODUCTS_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    poolProducts: null,
                },
            };
        case "POOL_RESPONSE_POST":
            return {
                ...state,
                post: {
                    ...state.post,
                    pool: action.value,
                },
            };
        case "POOL_RESPONSE_PATCH":
            return {
                ...state,
                patch: {
                    ...state.patch,
                    pool: action.value,
                },
            };
        case "POOL_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    pool: action.value,
                },
            };
        case "POOL_STATEMENT_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    poolStatement: action.value,
                },
            };
        case "POOL_IMAGE_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    poolImage: action.value,
                },
            };
        case "POOL_POI_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    poolPoi: action.value,
                },
            };
        // NEW: product-pool relation delete result
        case "PRODUCT_POOLS_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    productPools: action.value,
                },
            };
        case "POINTS_OF_INTEREST_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    pointsOfInterest: action.value,
                },
            };
        case "POINTS_OF_INTEREST_RESPONSE_RESET":
            return {
                ...state,
                get: {
                    ...state.get,
                    pointsOfInterest: null,
                },
            };
        // MAPPINGS: list and detail
        case "MAPPINGS_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    mappings: action.value,
                },
            };
        case "MAPPING_RESPONSE_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    mapping: action.value,
                },
            };
        // RESET: clear mapping detail get slice to avoid stale data between editor sessions
        case "RESET_MAPPING_GET":
            return {
                ...state,
                get: {
                    ...state.get,
                    mapping: null,
                },
            };
        // MAPPING: mutations
        case "MAPPING_RESPONSE_POST":
            return {
                ...state,
                post: {
                    ...state.post,
                    mapping: action.value,
                },
            };
        case "MAPPING_RESPONSE_PATCH":
            return {
                ...state,
                patch: {
                    ...state.patch,
                    mapping: action.value,
                },
            };
        case "MAPPING_RESPONSE_DELETE":
            return {
                ...state,
                delete: {
                    ...state.delete,
                    mapping: action.value,
                },
            };
        // MAPPING: batch orchestration result
        case "MAPPING_BATCH_RESPONSE":
            return {
                ...state,
                batch: {
                    ...state.batch,
                    mapping: action.value,
                },
            };
        case "PROPERTY_MAP_BATCH_RESPONSE":
            return {
                ...state,
                batch: {
                    ...state.batch,
                    propertyMap: action.value,
                },
            };
        case "AREA_BATCH_RESPONSE":
            return {
                ...state,
                batch: {
                    ...state.batch,
                    area: action.value,
                },
            };
        case "POOL_RESPONSE_BATCH":
            return {
                ...state,
                batch: {
                    ...state.batch,
                    pool: action.value,
                },
            };
        case "RESET_CABANAS_MAPPING_RESPONSES":
            return {
                ...state,
                get: { ...initialState.get },
                post: { ...initialState.post },
                patch: { ...initialState.patch },
                delete: { ...initialState.delete },
            };
        case "RESET_CABANAS_MAPPING_BATCH_RESPONSES":
            return {
                ...state,
                batch: { ...initialState.batch },
            };
        case "POOL_ADD_RESET":
            return {
                ...state,
                post: {
                    ...state.post,
                    pool: {},
                },
            };
        default:
            return state;
    }
};

export default cabanasMappingReducer;
